import React from "react";
import List from "semantic-ui-react/dist/commonjs/elements/List";
import Checkbox from "semantic-ui-react/dist/commonjs/modules/Checkbox";
import { AclAction, AclResource } from "../../../../types/acl";
import { FineGrainedPermission } from "../../../../types/permissions";
import { Role } from "../../../../types/roles";
import { exists } from "../../../../utils/utils";

import FineGranularityModal from "./FineGranularityModal";

type ActionProps = {
  role: Role | Record<string, never>;
  resource: AclResource;
  action: AclAction;
  checked: boolean;
  canEdit: boolean;
  onActionChange: (newAction: number, isChecked: boolean) => void;
  fineGranularity?: any[];
  fineGrainedPermissions: FineGrainedPermission[];
};

class Action extends React.PureComponent<ActionProps> {
  handleClick = () => {
    if (!this.props.canEdit) return;
    this.props.onActionChange(this.props.action.id, !this.props.checked);
  };

  render() {
    const {
      canEdit,
      checked,
      onActionChange,
      role,
      resource,
      action,
      fineGranularity,
      fineGrainedPermissions
    } = this.props;
    const fineGrainedPermission = fineGrainedPermissions.find(
      permission => permission.resourceActionId === action.id
    );
    const permissionFineGranularity = fineGranularity?.find(
      permission =>
        fineGrainedPermission && fineGrainedPermission.id === permission.fineGrainedResourceActionId
    );
    return (
      <List.Item>
        <b>{action.title}</b>
        {!exists(fineGrainedPermission) ? (
          <Checkbox
            aria-label="Action toggle"
            disabled={!canEdit}
            style={{ float: "right" }}
            checked={checked}
            onClick={this.handleClick}
          />
        ) : (
          <FineGranularityModal
            canEdit={canEdit}
            onActionChange={onActionChange}
            checked={checked}
            role={role}
            resource={resource}
            action={action}
            fineGranularity={permissionFineGranularity}
            fineGrainedPermission={fineGrainedPermission}
          />
        )}
      </List.Item>
    );
  }
}

export default Action;
